






















import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import {
  CloudFile,
  FetchState
} from "@/shared/types";
import { useCloudfileStore } from "@/shared/store/cloudfile";

@Component
export default class S3ResponseReader extends Vue {
  $validator: Validator;

  clouldFileStore = useCloudfileStore();

  @Prop()
  bucketName: string;
  @Prop()
  fileKey: string;
  @Prop()
  identifier: string;

  returnedFile: any = null;
  formModel: CloudFile;

  get hasLoadedFile () {
    return !!this.returnedFile;
  }

  get isWaiting () {
    return !this.hasLoadedFile && !this.isTimedOut;
  }

  get isTimedOut () {
    return this.clouldFileStore.getDownloadedLimitExceeded(this.identifier);
  }

  @Watch("hasLoadedFile")
  onHasLoadedFileChanged (newValue, oldValue) {
    if (newValue && !oldValue) {
      this.$emit("responseFileLoaded");
    }
  }

  @Watch("clouldFileStore.downloadedFiles")
  onFilesAdded () {
    const downloadedFile = this.clouldFileStore.getDownloadedFile(this.identifier);
    this.returnedFile = downloadedFile && downloadedFile.payload;
  }

  @Watch("identifier")
  onRoutechange () {
    this.onDownloadStart();
  }

  onDownloadStart () {
    this.formModel = {
      status: FetchState.Uninitialized,
      remoteFileName: this.fileKey,
      remoteAddress: this.bucketName,
      payload: null
    };
    this.clouldFileStore.downloadAndRetry({
      key: this.identifier,
      file: this.formModel
    });
  }

  created (): void {
    this.onDownloadStart();
  }
}
